import { render } from "./CompanyContactForm.vue?vue&type=template&id=67871c3f&scoped=true&ts=true"
import script from "./CompanyContactForm.vue?vue&type=script&lang=ts"
export * from "./CompanyContactForm.vue?vue&type=script&lang=ts"

import "./CompanyContactForm.vue?vue&type=style&index=0&id=67871c3f&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67871c3f"]])

export default __exports__